import { Grid } from "@mui/material"
import './Expense.css';
import _ from "lodash";
//icon
import { useInitExpensesDashboard } from "./init/useExpenses";
import CompareExpenses from "./CompareExpenses";
import YearlyExpenses from "./YearlyExpenses";
import BoxSearch from "./BoxSearch";

const ExpenseDashboard = () => {


    const { arrResult, option, arrYear, arrSection, setArrYear, setArrSection, arrMonth, setArrMonth, isCheckYear, setIsCheckYear, nYear, setNYear } = useInitExpensesDashboard();

    return (
        <Grid container>
            <div style={{ position: "relative", display: 'contents' }}>
                <div className="item-absolute-option">
                    <BoxSearch option={option} arrYear={arrYear} setArrYear={setArrYear} arrSection={arrSection} setArrSection={setArrSection} arrMonth={arrMonth} setArrMonth={setArrMonth} isCheckYear={isCheckYear} setIsCheckYear={setIsCheckYear} rYear={nYear} setrYear={setNYear} />
                </div>
                <Grid container spacing={2} style={{ padding: "2%" }}>
                    {
                        !isCheckYear ?
                            <Grid item xs={12} >
                                <CompareExpenses data={arrResult} arrYear={arrYear} setIsCheckYear={setIsCheckYear} setNYear={setNYear} setArrMonth={setArrMonth} />
                            </Grid>
                            :
                            <Grid item xs={12} >
                                <YearlyExpenses data={arrResult} nYear={nYear} />
                            </Grid>
                    }
                </Grid>
            </div>
        </Grid>
    )
}

export default ExpenseDashboard
